var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "employees-card-bottom" },
        [
          _c(
            "el-form",
            {
              staticClass: "from-s",
              attrs: { inline: true },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c("div", { staticClass: "flex-row flex-col" }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-tabs",
                      {
                        staticClass: "tabs",
                        on: { "tab-click": _vm.activeClick },
                        model: {
                          value: _vm.activeVal,
                          callback: function ($$v) {
                            _vm.activeVal = $$v
                          },
                          expression: "activeVal",
                        },
                      },
                      [
                        _c("el-tab-pane", {
                          attrs: { label: "我的岗位职责", name: "1" },
                        }),
                        _vm._v(" "),
                        _c("el-tab-pane", {
                          attrs: { label: "下级岗位职责", name: "2" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "splitLine mb20" }),
          _vm._v(" "),
          _vm.activeVal == 1
            ? _c("div", { staticClass: "main" }, [
                _vm.detailData.duty
                  ? _c("div", { staticClass: "detail-box" }, [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.detailData.name) + "岗位职责"),
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "content",
                        domProps: { innerHTML: _vm._s(_vm.detailData.duty) },
                      }),
                    ])
                  : _c(
                      "div",
                      [
                        _c("default-page", {
                          directives: [{ name: "height", rawName: "v-height" }],
                          attrs: { index: 12, "min-height": 580 },
                        }),
                      ],
                      1
                    ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.activeVal == 2
            ? _c(
                "div",
                { staticClass: "table-box" },
                [
                  _c(
                    "div",
                    { staticClass: "inTotal flex" },
                    [
                      _vm._v(
                        "\n        共 " +
                          _vm._s(_vm.totalSubmit) +
                          " 条\n        "
                      ),
                      _c("el-input", {
                        staticClass: "search-input",
                        attrs: {
                          clearable: "",
                          placeholder: "请输入姓名搜索",
                          "prefix-icon": "el-icon-search",
                          size: "small",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.getList(1)
                          },
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.getList(1)
                          },
                        },
                        model: {
                          value: _vm.where.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.where, "name", $$v)
                          },
                          expression: "where.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.tableData, height: _vm.tableHeight },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "序号", type: "index", width: "50" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "人员姓名", prop: "name" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "职位", prop: "job.name" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("toptable.department"),
                          "min-width": "140",
                          prop: "frame.name",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return _vm._l(
                                  scope.row.frames,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "frame-name over-text",
                                      },
                                      [
                                        _c("span", { staticClass: "icon-h" }, [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(item.name)
                                          ),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    item.is_mastart === 1 &&
                                                    scope.row.frames.length > 1,
                                                  expression:
                                                    "item.is_mastart === 1 && scope.row.frames.length > 1",
                                                },
                                              ],
                                              attrs: { title: "主部门" },
                                            },
                                            [_vm._v("(主)")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: item.is_admin == 1,
                                                  expression:
                                                    "item.is_admin == 1",
                                                },
                                              ],
                                              staticClass: "guan",
                                              attrs: { title: "主管" },
                                            },
                                            [_vm._v("(管)")]
                                          ),
                                        ]),
                                      ]
                                    )
                                  }
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          1658337130
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "更新时间", prop: "job.updated_at" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { fixed: "right", label: "操作", width: "130" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onCheck(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("查看")]
                                  ),
                                  _vm._v(" "),
                                  scope.row.operate
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "text",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onEdit(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("编辑")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          51252324
                        ),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "page-fixed" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.where.page,
                          "page-size": _vm.where.limit,
                          "page-sizes": [15, 20, 30],
                          total: _vm.totalSubmit,
                          layout: "total,sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "size-change": _vm.handleSizeChange,
                          "current-change": _vm.handleCurrentChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            "before-close": _vm.handleClose,
            visible: _vm.checkDrawer,
            direction: "rtl",
            size: "60%",
            title: "岗位职责表",
          },
          on: {
            "update:visible": function ($event) {
              _vm.checkDrawer = $event
            },
          },
        },
        [
          _vm.detailDataInfo
            ? _c("div", { staticClass: "check-box" }, [
                _c("div", {
                  staticClass: "content mt14",
                  domProps: { innerHTML: _vm._s(_vm.detailDataInfo) },
                }),
              ])
            : _c(
                "div",
                [
                  _c("default-page", {
                    directives: [{ name: "height", rawName: "v-height" }],
                    attrs: { index: 14, "min-height": 580 },
                  }),
                ],
                1
              ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            "before-close": _vm.handleClose,
            visible: _vm.editDrawer,
            wrapperClosable: false,
            direction: "rtl",
            size: "60%",
            title: "编辑岗位职责表",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editDrawer = $event
            },
          },
        },
        [
          _c("div", { staticClass: "check-box" }, [
            _c("div", { staticClass: "user-name" }, [
              _c("span", [_vm._v("人员姓名：")]),
              _vm._v(" "),
              _c("span", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.userName)),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "boder" },
              [
                _c(_vm.loadEdit, {
                  ref: "ueditorFrom",
                  tag: "component",
                  attrs: {
                    border: true,
                    content: _vm.content,
                    height: _vm.height,
                  },
                  on: { input: _vm.ueditorEdit },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "button from-foot-btn fix btn-shadow" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.editDrawer = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.loading,
                    size: "small",
                    type: "primary",
                  },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }